// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OKUb","field":"styles_field__2smEG","fieldCol":"styles_fieldCol__2XDSc","diffCol":"styles_diffCol__-SJ0V","diff":"styles_diff__36m_B"};